(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-start/assets/react/components/header-text.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-start/assets/react/components/header-text.js');
"use strict";


const Icon = svs.ui.ReactIcon;
const heroHeader = svs.lyckoplatsen.data.hero.heroHeader;
const HeaderText = () => React.createElement(React.Fragment, null, React.createElement("h1", {
  className: "header-text",
  style: (heroHeader === null || heroHeader === void 0 ? void 0 : heroHeader.color) === 'fc-white' ? {
    color: 'white'
  } : undefined
}, (heroHeader === null || heroHeader === void 0 ? void 0 : heroHeader.header) || ''), React.createElement("div", {
  className: "align-center f-left header-ab-test-b-content"
}, React.createElement("div", {
  className: "u-flex"
}, React.createElement(Icon, {
  icon: "win",
  color: "icon-inverted",
  className: "margin-right-1"
}), React.createElement("p", {
  className: "fc-white margin-bottom-1 f-400"
}, "Vinn upp till 1 miljon varje vecka")), React.createElement("div", {
  className: "u-flex"
}, React.createElement(Icon, {
  icon: "bingo",
  color: "icon-inverted",
  className: "margin-right-1"
}), React.createElement("p", {
  className: "fc-white margin-bottom-1 f-400"
}, "160 kr f\xF6r 4 veckor - 12 dragningar")), React.createElement("div", {
  className: "u-flex"
}, React.createElement("i", {
  className: "icon icon-300 icon-inverted margin-right-1"
}, React.createElement("svg", {
  className: "svg-icon svg-icon-charity",
  preserveAspectRatio: "xMidYMin slice",
  viewBox: "0 0 512 512",
  width: "1em",
  height: "1em"
}, React.createElement("path", {
  d: "M354.44,0c-41.8,0-78.36,21.97-98.45,54.62C235.9,21.97,199.34,0,157.54,0,94.2,0,42.67,50.27,42.67,112.06c0,30.01,12.21,57.23,31.89,77.43l38.41,37.52,95.67,93.45c-36.31,2.49-70.99,16.69-98.68,40.6-23.97,20.71-54.63,32.11-86.33,32.11H0v118.84s356.83,0,356.83,0c24.47,0,47.45-6.53,64.71-23.8l74.44-74.49c21.38-21.43,21.36-56.24-.04-77.62-21.42-21.44-56.27-21.43-77.68,0l-41.04,41.01c-10.37,10.37-24.15,16.07-38.8,16.07h-9.39c2.02-5.73,3.13-11.88,3.13-18.28,0-22.5-13.64-41.89-33.1-50.33l92.24-89.89,44.18-43.26c20.89-20.31,33.85-48.38,33.85-79.35,0-61.79-51.53-112.06-114.89-112.06ZM254.64,320.06h2.58l87.58-85.39,68.3-66.75c14.41-14.46,23.37-34.14,23.37-55.86,0-44.11-36.8-80-82.03-80-38.21,0-70.31,25.66-79.38,60.23h-38.15c-9.07-34.56-41.16-60.23-79.37-60.23-45.22,0-82.02,35.89-82.02,80,0,21.72,8.95,41.4,23.39,55.84l57.47,56.11,98.25,96.06ZM470.09,387.86c7.16-7.14,7.13-18.79-.01-25.93-7.17-7.16-18.8-7.15-25.97-.01l-41.05,41.01c-17.25,17.25-40.23,26.77-64.65,26.77h-131.17v-36.55h70.04c10.08,0,18.29-8.2,18.29-18.28s-8.2-18.28-18.29-18.28h-57.1c-31.69,0-62.32,11.39-86.31,32.09-27.27,23.55-65.94,37.75-101.87,40.51v46.24s324.82,0,324.82,0c14.68,0,28.45-2.71,38.83-13.08l74.44-74.49Z",
  fill: "#FFFFFF",
  fillRule: "evenodd"
}))), React.createElement("p", {
  className: "fc-white margin-bottom-1 f-400"
}, "Ditt spel bidrar till v\xE4lg\xF6renhet"))));
setGlobal('svs.lyckoplatsen.components.page_start.react.components', {
  HeaderText
});

 })(window);